/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BankBulkResponse } from '../models/bank-bulk-response';
import { BankResponse } from '../models/bank-response';
import { getApiBankV1Id$Json } from '../fn/bank/get-api-bank-v-1-id-json';
import { GetApiBankV1Id$Json$Params } from '../fn/bank/get-api-bank-v-1-id-json';
import { getApiBankV1Id$Plain } from '../fn/bank/get-api-bank-v-1-id-plain';
import { GetApiBankV1Id$Plain$Params } from '../fn/bank/get-api-bank-v-1-id-plain';
import { GetBankResponse } from '../models/get-bank-response';
import { postApiBankV1$Json } from '../fn/bank/post-api-bank-v-1-json';
import { PostApiBankV1$Json$Params } from '../fn/bank/post-api-bank-v-1-json';
import { postApiBankV1$Plain } from '../fn/bank/post-api-bank-v-1-plain';
import { PostApiBankV1$Plain$Params } from '../fn/bank/post-api-bank-v-1-plain';
import { postApiBankV1Bulk$Json } from '../fn/bank/post-api-bank-v-1-bulk-json';
import { PostApiBankV1Bulk$Json$Params } from '../fn/bank/post-api-bank-v-1-bulk-json';
import { postApiBankV1Bulk$Plain } from '../fn/bank/post-api-bank-v-1-bulk-plain';
import { PostApiBankV1Bulk$Plain$Params } from '../fn/bank/post-api-bank-v-1-bulk-plain';
import { postApiBankV1BulkDelete$Json } from '../fn/bank/post-api-bank-v-1-bulk-delete-json';
import { PostApiBankV1BulkDelete$Json$Params } from '../fn/bank/post-api-bank-v-1-bulk-delete-json';
import { postApiBankV1BulkDelete$Plain } from '../fn/bank/post-api-bank-v-1-bulk-delete-plain';
import { PostApiBankV1BulkDelete$Plain$Params } from '../fn/bank/post-api-bank-v-1-bulk-delete-plain';
import { putApiBankV1Bulk$Json } from '../fn/bank/put-api-bank-v-1-bulk-json';
import { PutApiBankV1Bulk$Json$Params } from '../fn/bank/put-api-bank-v-1-bulk-json';
import { putApiBankV1Bulk$Plain } from '../fn/bank/put-api-bank-v-1-bulk-plain';
import { PutApiBankV1Bulk$Plain$Params } from '../fn/bank/put-api-bank-v-1-bulk-plain';

@Injectable({ providedIn: 'root' })
export class BankService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiBankV1()` */
  static readonly PostApiBankV1Path = '/private/v1/banks';

  /**
   * Retrieves the list of all available banks entities.
   *
   * Retrieves the list of all available banks entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1$Plain$Response(params?: PostApiBankV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBankResponse>> {
    return postApiBankV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available banks entities.
   *
   * Retrieves the list of all available banks entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1$Plain(params?: PostApiBankV1$Plain$Params, context?: HttpContext): Observable<GetBankResponse> {
    return this.postApiBankV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetBankResponse>): GetBankResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all available banks entities.
   *
   * Retrieves the list of all available banks entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1$Json$Response(params?: PostApiBankV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBankResponse>> {
    return postApiBankV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available banks entities.
   *
   * Retrieves the list of all available banks entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1$Json(params?: PostApiBankV1$Json$Params, context?: HttpContext): Observable<GetBankResponse> {
    return this.postApiBankV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetBankResponse>): GetBankResponse => r.body)
    );
  }

  /** Path part for operation `getApiBankV1Id()` */
  static readonly GetApiBankV1IdPath = '/private/v1/banks/{id}';

  /**
   * Retrieves a Bank by ID.
   *
   * Retrieves a Bank by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiBankV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiBankV1Id$Plain$Response(params: GetApiBankV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankResponse>> {
    return getApiBankV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Bank by ID.
   *
   * Retrieves a Bank by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiBankV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiBankV1Id$Plain(params: GetApiBankV1Id$Plain$Params, context?: HttpContext): Observable<BankResponse> {
    return this.getApiBankV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankResponse>): BankResponse => r.body)
    );
  }

  /**
   * Retrieves a Bank by ID.
   *
   * Retrieves a Bank by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiBankV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiBankV1Id$Json$Response(params: GetApiBankV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BankResponse>> {
    return getApiBankV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Bank by ID.
   *
   * Retrieves a Bank by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiBankV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiBankV1Id$Json(params: GetApiBankV1Id$Json$Params, context?: HttpContext): Observable<BankResponse> {
    return this.getApiBankV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankResponse>): BankResponse => r.body)
    );
  }

  /** Path part for operation `putApiBankV1Bulk()` */
  static readonly PutApiBankV1BulkPath = '/private/v1/banks/bulk';

  /**
   * Updates a list in bulk of banks.
   *
   * Updates a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiBankV1Bulk$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiBankV1Bulk$Plain$Response(params?: PutApiBankV1Bulk$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return putApiBankV1Bulk$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a list in bulk of banks.
   *
   * Updates a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiBankV1Bulk$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiBankV1Bulk$Plain(params?: PutApiBankV1Bulk$Plain$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.putApiBankV1Bulk$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

  /**
   * Updates a list in bulk of banks.
   *
   * Updates a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiBankV1Bulk$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiBankV1Bulk$Json$Response(params?: PutApiBankV1Bulk$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return putApiBankV1Bulk$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a list in bulk of banks.
   *
   * Updates a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiBankV1Bulk$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiBankV1Bulk$Json(params?: PutApiBankV1Bulk$Json$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.putApiBankV1Bulk$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

  /** Path part for operation `postApiBankV1Bulk()` */
  static readonly PostApiBankV1BulkPath = '/private/v1/banks/bulk';

  /**
   * Inserts a list in bulk of banks.
   *
   * Inserts a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1Bulk$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1Bulk$Plain$Response(params?: PostApiBankV1Bulk$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return postApiBankV1Bulk$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Inserts a list in bulk of banks.
   *
   * Inserts a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1Bulk$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1Bulk$Plain(params?: PostApiBankV1Bulk$Plain$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.postApiBankV1Bulk$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

  /**
   * Inserts a list in bulk of banks.
   *
   * Inserts a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1Bulk$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1Bulk$Json$Response(params?: PostApiBankV1Bulk$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return postApiBankV1Bulk$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Inserts a list in bulk of banks.
   *
   * Inserts a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1Bulk$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1Bulk$Json(params?: PostApiBankV1Bulk$Json$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.postApiBankV1Bulk$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

  /** Path part for operation `postApiBankV1BulkDelete()` */
  static readonly PostApiBankV1BulkDeletePath = '/private/v1/banks/bulk-delete';

  /**
   * Soft deletes a list in bulk of banks.
   *
   * Soft deletes a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1BulkDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1BulkDelete$Plain$Response(params?: PostApiBankV1BulkDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return postApiBankV1BulkDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Soft deletes a list in bulk of banks.
   *
   * Soft deletes a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1BulkDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1BulkDelete$Plain(params?: PostApiBankV1BulkDelete$Plain$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.postApiBankV1BulkDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

  /**
   * Soft deletes a list in bulk of banks.
   *
   * Soft deletes a list in bulk of banks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiBankV1BulkDelete$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1BulkDelete$Json$Response(params?: PostApiBankV1BulkDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
    return postApiBankV1BulkDelete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Soft deletes a list in bulk of banks.
   *
   * Soft deletes a list in bulk of banks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiBankV1BulkDelete$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiBankV1BulkDelete$Json(params?: PostApiBankV1BulkDelete$Json$Params, context?: HttpContext): Observable<BankBulkResponse> {
    return this.postApiBankV1BulkDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BankBulkResponse>): BankBulkResponse => r.body)
    );
  }

}
